export default __webpack_public_path__ + "static/media/coin-money.f87d589e.png";